import {chain, partialRight, intersectionWith} from 'lodash'
import {Link} from 'react-router-dom'
import React from 'react'
import Text from 'react-text'
import {Consumer} from '../../context'
import './language-filter.styl'

function LanguageFilterButton ({id, selected}) {
  const query = {languageId: id}
  return (<Consumer key={id}>{ context => {
    return (
      <Link
        className={`language-filter ${selected ? 'selected' : ''}`}
        onClick={(e) => selected && e.preventDefault()}
        to={context.link({},context.match.params,{query})}
      >
        <Text id={`${id}_label`} />
      </Link>
    )
  }}</Consumer>)
}

export default function LanguageFilter (props) {
  const {availableLanguages} = props
  const filter = availableLanguages
    ? partialRight(intersectionWith, availableLanguages, (a, b) => a.id == b)
    : a => a
  return (
    <Consumer>{ (context) => {
      const selectedLanguage = context.query.languageId || context.languageId
      const languages = chain(filter(context.languages))
        .orderBy(['id'],['desc'])
        .map(l => ({...l, selected: l.id == selectedLanguage}))
        .map(LanguageFilterButton)
        .value()
      return (
        <div className="language filter">
          {languages}
        </div>
      )}}</Consumer>
  )
}
